import AdsMappersFactory from '../../ads/Mappers/factory.js'
import {AlertInteractionUserAlertsValueObject} from '../ValueObjects/AlertInteractionUserAlertsValueObject.js'
import {MatchesListUserAlertsValueObject} from '../ValueObjects/MatchesListUserAlertsValueObject.js'
import {MatchUserAlertsValueObject} from '../ValueObjects/MatchUserAlertsValueObject.js'

export class HTTPMatchesResponseToMatchesListValueObjectMapper {
  #fromAdRawDataToAdEntityMapper
  #config

  constructor({fromAdRawDataToAdEntityMapper, config}) {
    this.#fromAdRawDataToAdEntityMapper = fromAdRawDataToAdEntityMapper
    this.#config = config
  }

  static create({config}) {
    return new HTTPMatchesResponseToMatchesListValueObjectMapper({
      fromAdRawDataToAdEntityMapper: AdsMappersFactory.fromAdRawDataToAdEntityMapper({config}),
      config
    })
  }

  map({items, search}) {
    if (!items) return MatchesListUserAlertsValueObject.create({items: [], search, config: this.#config})

    const mappedItems = items.map(item => {
      const {alertData, ...adData} = item

      const adEntity = this.#fromAdRawDataToAdEntityMapper.map(adData)
      const alertInteractionValueObject = AlertInteractionUserAlertsValueObject.create(alertData)

      return MatchUserAlertsValueObject.create({
        ad: adEntity.toJSON(),
        alertInteraction: alertInteractionValueObject.toJSON()
      })
    })

    return MatchesListUserAlertsValueObject.create({items: mappedItems, search, config: this.#config})
  }
}
